// src/components/dashboard/DashboardShell.jsx

export default function DashboardShell({ title, subtitle, children }) {
  return (
    <div
      className="
        h-full
        p-6
        bg-bg
        text-gray-100
        overflow-y-auto
      "
    >
      {/* =========================
          HEADER
      ========================= */}
      <header
        className="
          pb-4
          border-b border-slate-800
        "
      >
        <h1 className="text-[22px] font-semibold tracking-wide">
          {title}
        </h1>

        {subtitle && (
          <p className="mt-1 text-sm text-gray-400">
            {subtitle}
          </p>
        )}
      </header>

      {/* =========================
          CONTENT
      ========================= */}
      <section className="mt-6 space-y-6">
        {children}
      </section>
    </div>
  );
}